import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { setSelectedEdge } from '../../../features/networkSlice';

export default function handler(props) {
  const { visible } = props; // indicates if the tab is visible (otherwise DataGrid will complain)
  const edges = useSelector((state) => state.networkUndo.present.edges);
  const highlightedNodes = useSelector((state) => state.network.highlightedNodes) || [];
  const highlightedEdges = useSelector((state) => state.network.highlightedEdges) || [];
  // console.log(highlightedNodes, highlightedEdges);
  // const filteredEdges = edges;
  const filteredEdges = edges.filter(
    (edge) => (highlightedNodes.length === 0 && highlightedEdges.length === 0)
      || (highlightedNodes.includes(edge.to) || highlightedNodes.includes(edge.from))
      || highlightedEdges.includes(edge.id),
  );
  const nodes = useSelector((state) => state.networkUndo.present.nodes);
  const nodesById = nodes.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {});
  const edgeTypes = { circle: 'Negative', triangle: 'Positive' };
  const columns = [
    {
      field: 'to',
      flex: 2,
      headerName: 'To',
      valueFormatter: (params) => nodesById[params.value]?.label,
    },
    {
      field: 'from',
      flex: 2,
      headerName: 'From',
      valueFormatter: (params) => nodesById[params.value]?.label,
    },
    { field: 'title', flex: 3, headerName: 'Title' },
    {
      field: 'edgeType',
      flex: 1,
      headerName: 'Type',
      valueGetter: (item) => ('arrows' in item.row ? edgeTypes[item.row.arrows.to.type] : 'n/a'),
    },
  ];
  const initialState = { pagination: { paginationModel: { pageSize: 50 } } };

  const dispatch = useDispatch();

  const onRowClick = (e) => { // 'onRowDoubleClick' also available
    dispatch(setSelectedEdge(e.row));
  };

  function CustomFilter() {
    return <GridToolbarQuickFilter sx={{ p: 2 }} />;
  }

  return (visible && (
    <>
      <DataGrid
        autoHeight
        getRowHeight={() => 'auto'}
        sx={{
          '& .MuiDataGrid-cell': {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            alignItems: 'start',
            py: 1,
          },
          border: 0,
        }}
        rows={filteredEdges}
        columns={columns}
        initialState={initialState}
        onRowClick={onRowClick}
        disableRowSelectionOnClick
        pageSizeOptions={[5, 10, 25, 50]}
        components={{ Toolbar: CustomFilter }}
      />
      {(highlightedEdges.length > 0 || highlightedNodes.length > 0) && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          The rows are filtered based on selections
        </Alert>
      )}
    </>
  ));

  // {'arrows' in node ? edgeTypes[item.arrows.to.type] : 'n/a'}
}
